import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import health from "../../Assets/Projects/health.png";
import cvimage from "../../Assets/Projects/cvimage.png";
import lulcpic from "../../Assets/Projects/lulcpic.png";
import wc_pred from "../../Assets/Projects/wc_pred.png";
import ui_path_bot from "../../Assets/Projects/ui_path_bot.png";
import pbi_resume from "../../Assets/Projects/pbi_resume.png";
import network_topo from "../../Assets/Projects/network_topo.jpg";
import ir_result from "../../Assets/Projects/ir_result.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
	<Col md={4} className="project-card">
            <ProjectCard
              imgPath={pbi_resume}
              isBlog={false}
              title="My Data Story in PowerBI"
              description="A personal portfolio project showcasing data visualization and analytics using Microsoft Power BI. This project demonstrates skills in data storytelling, interactive dashboard creation, and business intelligence."
              ghLink="https://community.fabric.microsoft.com/t5/Contests-Gallery/My-Data-Story-in-PowerBI/td-p/4885971"
            />
          </Col>

	<Col md={4} className="project-card">
            <ProjectCard
              imgPath={ir_result}
              isBlog={false}
              title="Case Study on AI Sustainability"
              description= "Detect Carbon emissions using python libraries in various stages of AI Product Lifecycle. This Legal Information Retrieval System is taken as a usecase and its Energy Emissions are captured. This project was presented at the 15th ICEEE 2024 Online International Annual Conference, held on November 21st and 22nd, 2024, at Obuda University, Budapest, Hungary."
              ghLink= "https://github.com/JeninaAngelin/Case-Study-on-AI-Sustainbility"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ui_path_bot}
              isBlog={false}
              title="EMI Reminder System"
              description="An automated tool designed to assist users in managing their Equated Monthly Installments (EMIs) effectively. By leveraging UiPath's automation capabilities, this system sends timely reminders via email to ensure users never miss a payment deadline."
              ghLink="https://github.com/JeninaAngelin/Automated-EMI-Reminder-System"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

	<Col md={4} className="project-card">
            <ProjectCard
              imgPath={health}
              isBlog={false}
              title="IDB-Analytics"
              description="Patient Insights Project : Explore our analysis of surgical and hospital data acquired by XYZ Medical Solutions. Uncover key demographic trends, market opportunities, and actionable insights to guide strategic decisions."
              ghLink="https://github.com/JeninaAngelin/IDB-Analytics"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>
          
<Col md={4} className="project-card">
            <ProjectCard
              imgPath={lulcpic}
              isBlog={false}
              title="Land Use Land Cover Mapping using neural-cellular models"
              description="This work analyzes land use changes in the Western Ghats using Sentinel-2 satellite imagery and evaluates nine distinct land use classes, including water, trees, and built areas, using advanced modeling techniques like Artificial Neural Networks and Multi-Criteria Evaluation."        
              ghLink= "https://github.com/JeninaAngelin/LULC-Mapping-using-QGIS"
           />
          </Col>
	
<Col md={4} className="project-card">
            <ProjectCard
              imgPath={cvimage}
              isBlog={false}
              title="Computer Vision on Products"
              description="Developing a system to automatically extract and interpret information from product labels using Computer Vision (CV) techniques. The primary objective was to enhance the efficiency and accuracy of product data extraction for inventory management and quality control processes in retail and manufacturing industries. "        
              ghLink= "https://github.com/JeninaAngelin/Computer-Vision-Project"
           />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={network_topo}
              isBlog={false}
              title="Network Topology Analysis of College Lab Block"
              description= "Conducted an in-depth analysis of the network topology for the college lab block using Packet Tracer."
              ghLink="https://github.com/JeninaAngelin/Network-Analysis"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

	<Col md={4} className="project-card">
            <ProjectCard
              imgPath={wc_pred}
              isBlog={false}
              title="ICC WC Prediction 2023"
              description="This project won the Data Analytics Challenge of IIM, Vizag 2024. The ICC Cricket World Cup Prediction 2023 is an analytical model designed to forecast the outcomes of matches and predict the overall winner of the ICC Cricket World Cup tournament held in 2023. "
              ghLink="https://github.com/JeninaAngelin/Predicting-winner-of-ODI-World-Cup-2023"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Iris Data Manipulation"
              description= "Using SPSS, conducted statistical analysis to identify patterns and correlations within the data. Additionally, I implemented various machine learning algorithms using Python to predict species based on the given features. The project provided hands-on experience in data manipulation, statistical analysis, and machine learning techniques."
              ghLink= "https://github.com/JeninaAngelin/Iris-Data-Classification-Analysis-using-SPSS"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
                 
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
